import { items } from '../shared/formItems';


export interface FormValidationIssue {
  index: number;
  blockName: string;
  label: string;
  message: string;
}

export const NON_INPUT_KEYS = new Set([
  'WorkflowPreview',
  'Header',
  'Paragraph',
  'LineBreak',
  'Image',
  'CustomButton',
  'PaymentSection',
  'KycButton',
  'ESignButton',
  'ColumnRow',
  'TwoColumnRow',
  'ThreeColumnRow',
]);

/** Toolbox name per block key, so an issue names the block the author dropped. */
const BLOCK_NAMES: Record<string, string> = items.reduce(
  (acc: Record<string, string>, item: any) => {
    if (item?.key && item?.name) acc[item.key] = item.name;
    return acc;
  },
  {},
);

/** Strips the rich-text markup a Display Label carries. */
const labelText = (field: any): string =>
  String(field?.label ?? '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();

export const validateFormFields = (
  fields: any[],
): FormValidationIssue[] => {
  if (!Array.isArray(fields) || !fields.length) {
    return [
      {
        index: -1,
        blockName: '',
        label: '',
        message: 'Add at least one field before saving.',
      },
    ];
  }

  const issues: FormValidationIssue[] = [];
  const seenNames = new Map<string, number>();

  fields.forEach((field, index) => {

    if (field?.static || NON_INPUT_KEYS.has(field?.key)) return;

    const name = String(field?.field_name ?? '').trim();
    const blockName = BLOCK_NAMES[field?.key] || field?.key || 'Field';
    const label = labelText(field);

    if (!name) {
      issues.push({
        index,
        blockName,
        label,
        message: 'has no field name.',
      });
      return;
    }

    // The name is the key the answer is submitted under, so a repeat means one
    // field's response silently overwrites the other's.
    const firstIndex = seenNames.get(name);
    if (firstIndex !== undefined) {
      issues.push({
        index,
        blockName,
        label,
        message: `reuses the field name "${name}" — names must be unique.`,
      });
    } else {
      seenNames.set(name, index);
    }
  });

  return issues;
};

export default validateFormFields;
